var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"weui-cell"},[_c('div',{staticClass:"weui-cell__bd"},[_c(_vm.view,{tag:"component",staticClass:"weui-btn_cell",attrs:{"to":_vm.to,"role":"button"},on:{"click":function($event){_vm.$emit('click')}}},[_vm._t("default")],2)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-496c62cd","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/weui/button-cell/Index.vue
// module id = null
// module chunks = 